import { render, staticRenderFns } from "./AddEditSponsors.vue?vue&type=template&id=e577b8ea&scoped=true"
import script from "./AddEditSponsors.vue?vue&type=script&lang=js"
export * from "./AddEditSponsors.vue?vue&type=script&lang=js"
import style0 from "./AddEditSponsors.vue?vue&type=style&index=0&id=e577b8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e577b8ea",
  null
  
)

export default component.exports